<template>
    <div>
        <b-modal 
            :model-value="modalEditaCuenta" 
            :no-close-on-backdrop="true" 
            hide-footer 
                        centered 
            size="lg"
            header-class="reset-modal-header"
            title-class="reset-modal-title"
            :title="labels.title"
         @hide="clicked">
            <div class="uniform-modal-body">
                <!-- Contable (solo lectura) -->
                <b-row class="d-flex align-items-center uniform-form-row">
                    <b-col cols="12" md="3" class="text-left uniform-label-col">
                        <label class="form-label">{{ labels.contable }}</label>
                    </b-col>
                    <b-col cols="12" md="9" class="text-left">
                        <h6 style="margin: 0; padding-top: 6px; font-size: 14px; font-weight: 500;">{{ contable === 1 ? 'SI' : 'NO' }}</h6>
                    </b-col>
                </b-row>

                <!-- Cuenta (solo lectura) -->
                <b-row class="d-flex align-items-center uniform-form-row" v-if="contable === 1">
                    <b-col cols="12" md="3" class="text-left uniform-label-col">
                        <label class="form-label">{{ labels.account }}</label>
                    </b-col>
                    <b-col cols="12" md="9" class="text-left">
                        <h6 style="margin: 0; padding-top: 6px; font-size: 14px; font-weight: 500;">{{ cuenta || '-' }}</h6>
                    </b-col>
                </b-row>

                <!-- Actual -->
                <b-row class="d-flex align-items-center uniform-form-row">
                    <b-col cols="12" md="3" class="text-left uniform-label-col">
                        <label class="form-label">{{ labels.actual }}</label>
                    </b-col>
                    <b-col cols="12" md="9" class="text-left">
                        <b-form-select v-model="actual" class="form-input">
                            <option value="1">{{ labels.yes }}</option>
                            <option value="0">{{ labels.no }}</option>
                        </b-form-select>
                    </b-col>
                </b-row>

                <!-- Operación -->
                <b-row class="d-flex align-items-center uniform-form-row">
                    <b-col cols="12" md="3" class="text-left uniform-label-col">
                        <label class="form-label">{{ labels.operacion }}</label>
                    </b-col>
                    <b-col cols="12" md="9" class="text-left">
                        <b-form-select v-model="operacion" class="form-input">
                            <option value="+">{{ labels.sumar }}</option>
                            <option value="-">{{ labels.restar }}</option>
                        </b-form-select>
                    </b-col>
                </b-row>

                <!-- Formulación (Contable = NO) -->
                <b-row class="d-flex align-items-center uniform-form-row" v-if="contable === 0">
                    <b-col cols="12" md="3" class="text-left uniform-label-col">
                        <label class="form-label">{{ labels.formulacion }}</label>
                    </b-col>
                    <b-col cols="12" md="9" class="text-left">
                        <div class="d-flex flex-wrap align-items-center gap-3">
                            <div class="custom-checkbox-wrapper">
                                <input 
                                    type="radio"
                                    id="chk_s"
                                    value="s"
                                    v-model="chk"
                                    @change="actualizarVistaFormulacion"
                                />
                                <label for="chk_s">Suma</label>
                            </div>
                            <div class="custom-checkbox-wrapper">
                                <input 
                                    type="radio"
                                    id="chk_n"
                                    value="n"
                                    v-model="chk"
                                    @change="actualizarVistaFormulacion"
                                />
                                <label for="chk_n">Niif</label>
                            </div>
                            <div class="custom-checkbox-wrapper" v-if="administrador">
                                <input 
                                    type="radio"
                                    id="chk_m"
                                    value="m"
                                    v-model="chk"
                                    @change="actualizarVistaFormulacion"
                                />
                                <label for="chk_m">Valor Manual</label>
                            </div>
                            <div class="custom-checkbox-wrapper" v-if="administrador">
                                <input 
                                    type="radio"
                                    id="chk_a"
                                    value="a"
                                    v-model="chk"
                                    @change="actualizarVistaFormulacion"
                                />
                                <label for="chk_a">Ajuste Consolidacion</label>
                            </div>
                            <div class="custom-checkbox-wrapper" v-if="administrador">
                                <input 
                                    type="radio"
                                    id="chk_ac"
                                    value="ac"
                                    v-model="chk"
                                    @change="actualizarVistaFormulacion"
                                />
                                <label for="chk_ac">Ajuste Combinacion</label>
                            </div>
                        </div>
                    </b-col>
                </b-row>

                <!-- Suma -->
                <b-row class="d-flex align-items-center uniform-form-row" v-if="showSuma">
                    <b-col cols="12" md="3" class="text-left uniform-label-col">
                        <label class="form-label">Suma:</label>
                    </b-col>
                    <b-col cols="12" md="9" class="text-left">
                        <b-form-input v-model="formulacion" type="text" class="form-input" />
                    </b-col>
                </b-row>

                <!-- NIIF -->
                <template v-if="showNiif">
                    <b-row class="d-flex align-items-center uniform-form-row">
                        <b-col cols="12" md="3" class="text-left uniform-label-col">
                            <label class="form-label" style="font-size: 14px; font-weight: 500; color: #495057;">
                                {{ labels.niifFilter }}
                            </label>
                        </b-col>
                        <b-col cols="12" md="9" class="text-left">
                            <div class="criterio-inputs-wrapper">
                                <b-form-input 
                                    v-model="critNiifCode" 
                                    type="text" 
                                    class="form-input"
                                    style="height: 34px; font-size: 13px; margin-bottom: 6px;"
                                    autocomplete="off"
                                    :placeholder="labels.niifCodePlaceholder"
                                    @input="filtraNiifs"
                                />
                                <b-form-input 
                                    v-model="critNiifName" 
                                    type="text" 
                                    class="form-input"
                                    style="height: 34px; font-size: 13px;"
                                    autocomplete="off"
                                    :placeholder="labels.niifNamePlaceholder"
                                    @input="filtraNiifs"
                                />
                            </div>
                        </b-col>
                    </b-row>

                    <div class="accounts-section mt-2">
                        <div v-if="listNiifFiltered.length > 0" class="accounts-list mt-1">
                            <div class="select-all-container mb-2 d-flex align-items-center justify-content-between">
                                <b-button 
                                    size="sm"
                                    style="background-color: #2e507a; border-color: #2e507a; font-size: 13px; padding: 4px 16px; border-radius: 4px; color: white;"
                                    @click="toggleSelectAllNiifs"
                                >
                                    {{ selectAllNiifs ? labels.deselectAll : labels.selectAll }}
                                </b-button>
                                <span style="font-size: 13px; color: #6c757d;">
                                    {{ labels.selected }}: <strong>{{ selectedNiifs.length }}</strong> / {{ listNiifFiltered.length }}
                                </span>
                            </div>

                            <div class="custom-scroll-table">
                                <table class="table table-sm table-hover" style="font-size: 13px; margin-bottom: 0;">
                                    <thead style="position: sticky; top: 0; background: #f8f9fa; z-index: 1;">
                                        <tr>
                                            <th style="width: 120px; font-weight: 600; font-size: 12px; color: #495057; padding: 6px 8px;">
                                                {{ labels.code }}
                                            </th>
                                            <th style="font-weight: 600; font-size: 12px; color: #495057; padding: 6px 8px;">
                                                {{ labels.niifName }}
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr 
                                            v-for="niif in listNiifFiltered" 
                                            :key="niif.id"
                                            @click="toggleNiifSelection(niif)"
                                            :class="{'table-active-blue': isNiifSelected(niif)}"
                                            style="cursor: pointer;"
                                        >
                                            <td style="padding: 5px 8px; border-radius: 8px 0 0 8px;">
                                                <strong>{{ niif?.niif || '' }}</strong>
                                            </td>
                                            <td style="padding: 5px 8px; border-radius: 0 8px 8px 0;" :title="niif.nameNiif">
                                                {{ niif?.nameNiif || '' }}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        <div v-else-if="listNiif.length > 0 && !loadingNiifs" class="text-center py-2" style="height: 150px; display: flex; align-items: center; justify-content: center;">
                            <span class="text-muted" style="font-size: 13px;">{{ labels.noNiifsMatch }}</span>
                        </div>

                        <div v-else-if="loadingNiifs" class="text-center py-2" style="height: 150px; display: flex; align-items: center; justify-content: center;">
                            <b-spinner small class="mr-1"></b-spinner>
                            <span style="font-size: 13px;">{{ labels.loadingNiifs }}</span>
                        </div>

                        <div v-else class="text-center py-2" style="height: 150px; display: flex; align-items: center; justify-content: center;">
                            <span class="text-muted" style="font-size: 13px;">{{ labels.noNiifsAvailable }}</span>
                        </div>
                    </div>
                </template>

                <div class="reset-dialog-actions d-flex justify-content-end mt-4">
                    <b-button class="reset-btn-secondary" @click="clicked">{{ labels.close }}</b-button>
                    <b-button class="reset-btn-primary ml-2" @click="guardaCuenta">{{ labels.save }}</b-button>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
import PlanConsolidacion from '../../services/PlanConsolidacion'
import Nivel from '../../services/Nivel'

export default {
    name: "EditaCuenta",
    props: ["modalEditaCuenta", "dataDetallCuent", "vigComSelected"],
    data: () => ({
        administrador: false,
        cuenta: "",
        contable: "",
        actual: "",
        operacion: "",
        vigencia: "",
        id_compania: "",
        codReporte: "",
        nivel_1: "",
        nivel_2: "",
        nivel_3: "",
        nivel_4: "",
        showCuenta: false,
        showFormulacion: false,
        chk: '',
        showNiif: false,
        showSuma: false,
        sumNiv: "",
        listNiif: [],
        arrNiif: [],
        nivelSelected: {},
        repPrincipal: {},
        searchNiif: "",
        searchNivel: "",
        selectedNiifs: [],
        selectAll: false,
        filteredNiif: [],
        info: {},
        formulacion: "",
        // Nuevas variables para el diseño mejorado
        listNiifFiltered: [],
        selectAllNiifs: false,
        loadingNiifs: false,
        critNiifCode: '',
        critNiifName: ''
    }),
    computed: {
        labels() {
            if (this.$store.state._language == "es-ES") {
                return {
                    title: "Editar Cuenta",
                    select: "Seleccione...",
                    save: "Guardar",
                    close: "Cerrar",
                    contable: "Contable:",
                    yes: "SI",
                    no: "NO",
                    account: "Cuenta:",
                    actual: "Actual:",
                    operacion: "Operación:",
                    sumar: "+",
                    restar: "-",
                    formulacion: "Formula:",
                    vigencia: "Vigencia:",
                    company: "Compañía:",
                    searchPlaceholder: "Buscar NIIF...",
                    searchPlaceholderNivel: "Buscar Nivel...",
                    selected: "Seleccionados",
                    noResults: "No se encontraron resultados",
                    niifFilter: "Filtro NIIF",
                    niifCodePlaceholder: "Buscar por código...",
                    niifNamePlaceholder: "Buscar por nombre...",
                    code: "Código",
                    niifName: "Nombre NIIF",
                    noNiifsAvailable: "No hay NIIF disponibles",
                    noNiifsMatch: "No hay NIIF que coincidan con el filtro",
                    loadingNiifs: "Cargando NIIF...",
                    selectAll: "Seleccionar todas",
                    deselectAll: "Deseleccionar todas",
                    noAccountsFound: "No se encontraron cuentas"
                }
            } else {
                return {
                    title: "Edit Account",
                    select: "Select...",
                    save: "Save",
                    close: "Close",
                    contable: "Accountant:",
                    yes: "YES",
                    no: "NO",
                    account: "Account:",
                    actual: "Actual:",
                    operacion: "Operation:",
                    sumar: "+",
                    restar: "-",
                    formulacion: "Formula:",
                    vigencia: "Validity:",
                    company: "Company:",
                    searchPlaceholder: "Search NIIF...",
                    searchPlaceholderNivel: "Search Level...",
                    selected: "Selected",
                    noResults: "No result found",
                    niifFilter: "NIIF Filter",
                    niifCodePlaceholder: "Search by code...",
                    niifNamePlaceholder: "Search by name...",
                    code: "Code",
                    niifName: "NIIF Name",
                    noNiifsAvailable: "No NIIF available",
                    noNiifsMatch: "No NIIF match the filter",
                    loadingNiifs: "Loading NIIF...",
                    selectAll: "Select all",
                    deselectAll: "Deselect all",
                    noAccountsFound: "No accounts found"
                }
            }
        }
    },
    methods: {
        // ===== MÉTODOS PARA NIIF =====
        isNiifSelected(niif) {
            if (!niif || niif.niif === undefined || niif.niif === null) return false
            return this.selectedNiifs.some(item => String(item) === String(niif.niif))
        },

        toggleNiifSelection(niif) {
            if (!niif || niif.niif === undefined || niif.niif === null) return
            const niifStr = String(niif.niif)
            const index = this.selectedNiifs.findIndex(item => String(item) === niifStr)
            if (index > -1) {
                this.selectedNiifs.splice(index, 1)
            } else {
                this.selectedNiifs.push(niif.niif)
            }
            this.updateSelectAllNiifs()
        },

        toggleSelectAllNiifs() {
            this.selectAllNiifs = !this.selectAllNiifs
            const selectedNiifsStr = this.selectedNiifs.map(item => String(item))
            
            if (this.selectAllNiifs) {
                const allCodes = this.listNiifFiltered.map(n => n?.niif).filter(code => code !== undefined && code !== null)
                allCodes.forEach(code => {
                    const codeStr = String(code)
                    if (!selectedNiifsStr.includes(codeStr)) {
                        this.selectedNiifs.push(code)
                    }
                })
            } else {
                const allCodes = this.listNiifFiltered.map(n => n?.niif).filter(code => code !== undefined && code !== null)
                const codesStr = allCodes.map(c => String(c))
                this.selectedNiifs = this.selectedNiifs.filter(code => !codesStr.includes(String(code)))
            }
        },

        updateSelectAllNiifs() {
            if (this.listNiifFiltered.length === 0) {
                this.selectAllNiifs = false
                return
            }
            const allCodes = this.listNiifFiltered.map(n => n?.niif).filter(code => code !== undefined && code !== null)
            const selectedNiifsStr = this.selectedNiifs.map(item => String(item))
            this.selectAllNiifs = allCodes.every(code => selectedNiifsStr.includes(String(code)))
        },

        filtraNiifs() {
            let filtered = [...this.listNiif]
            
            if (this.critNiifCode) {
                const codeFilter = this.critNiifCode.toUpperCase()
                filtered = filtered.filter(n => {
                    const code = n?.niif
                    if (code === undefined || code === null) return false
                    return String(code).toUpperCase().includes(codeFilter)
                })
            }
            
            if (this.critNiifName) {
                const nameFilter = this.critNiifName.toUpperCase()
                filtered = filtered.filter(n => {
                    const name = n?.nameNiif
                    if (name === undefined || name === null) return false
                    return String(name).toUpperCase().includes(nameFilter)
                })
            }
            
            this.listNiifFiltered = filtered
            this.updateSelectAllNiifs()
        },

        cargarNiif() {
            if (this.vigComSelected.vigencia == "") {
                this.$toast.error("El campo vigencia debe estar diligenciado")
                return
            }
            
            this.loadingNiifs = true
            
            PlanConsolidacion.getPlanConsPorCompVige(
                this.vigComSelected.vigencia,
                this.vigComSelected.codReporte
            )
            .then((res) => {
                const niifData = res.data.planConsNiif || []
                this.listNiif = niifData
                this.listNiifFiltered = [...niifData]
                this.updateSelectAllNiifs()
                this.loadingNiifs = false
            })
            .catch((err) => {
                console.log(err)
                this.listNiif = []
                this.listNiifFiltered = []
                this.loadingNiifs = false
            })
        },

        actualizarVistaFormulacion() {
            if (this.chk == 'n') {
                this.cargarNiif()
                this.showNiif = true
                this.showSuma = false
            } else if (this.chk == 's') {
                this.showSuma = true
                this.showNiif = false
                this.selectedNiifs = []
            } else {
                this.showSuma = false
                this.showNiif = false
                this.selectedNiifs = []
            }
        },

        // ===== MÉTODOS ORIGINALES =====
        f_nuevo_criterio_niif() {
            this.filteredNiif = this.f_filteredNiif()
        },

        f_filteredNiif() {
            const niif = this.searchNiif.toLowerCase() || ""
            const nivel = this.searchNivel.toLowerCase() || ""
            const listParcial = this.listNiif.filter(n =>
                n.niif.toString().includes(niif) || 
                (n.nameNiif && n.nameNiif.toLowerCase().includes(niif)) || 
                (n.descripcion && n.descripcion.toLowerCase().includes(niif))
            )
            return listParcial?.filter(n =>
                n.primer_nivel.toString().includes(nivel) || 
                n.segundo_nivel.toString().includes(nivel) || 
                (n.namePrimerNivel && n.namePrimerNivel.toLowerCase().includes(nivel)) || 
                (n.nameSegundoNivel && n.nameSegundoNivel.toLowerCase().includes(nivel))
            )
        },

        toggleSelectAll() {
            this.filteredNiif.forEach(n => {
                if (n._selected === true) {
                    n._selected = false
                } else {
                    n._selected = true
                }
            })
            this.selectedNiifs = this.listNiif.filter(n => n._selected)
        },

        updateSelectAllState() {
            if (this.filteredNiif.length === 0) {
                this.selectAll = false
                return
            }
            this.selectAll = this.filteredNiif.every(n => n._selected)
        },

        guardaCuenta() {
            if (this.chk == 'n') {
                if (this.selectedNiifs.length == 0) {
                    this.$toast.error("Niif sin seleccionar")
                    return
                }
            }

            this.info.chkSel = this.chk
            this.info.actual = this.actual
            this.info.operacion = this.operacion
            this.info.idUser = this.$store.state.userId

            if (this.chk == 'm') {
                this.info.formulacion = "MANUAL"
            } else if (this.chk == 'n') {
                this.arrNiif = this.selectedNiifs
                this.info.formulacion = this.arrNiif
            } else if (this.chk == 's') {
                this.info.formulacion = this.formulacion
            } else if (this.chk == 'a') {
                this.info.formulacion = "AC"
            } else if (this.chk == 'ac') {
                this.info.formulacion = "MC"
            }

            const service = this.$route.params.tipo == 'directo'
                ? Nivel.updateCuentaNivelEfe
                : Nivel.updateCuentaNivelEfeInd

            service(this.info)
                .then((res) => {
                    this.$toast.success(res.data.message)
                    this.clicked()
                })
                .catch((err) => {
                    console.log(err)
                })
                .finally(() => {
                    setTimeout(() => {
                        this.reloadTable()
                    }, 2000)
                })
        },

        clicked() {
            this.$emit('clicked', false)
        },

        reloadTable() {
            if (this.dataDetallCuent && this.dataDetallCuent.length > 0) {
                this.nivelSelected = {
                    'nivelUno': this.dataDetallCuent[0].nivel_1,
                    'nivelDos': this.dataDetallCuent[0].nivel_2,
                    'nivelTres': this.dataDetallCuent[0].nivel_3,
                    'nivelCuatro': this.dataDetallCuent[0].nivel_4
                }
                this.$emit('reloadTable', this.nivelSelected, this.dataDetallCuent[0].vigencia, this.dataDetallCuent[0].id_compania, this.vigComSelected.codReporte)
            }
        },

        clearFields() {
            this.actual = ""
            this.operacion = ""
            this.chk = ""
            this.formulacion = ""
            this.niifSelect = []
            this.listNiif = []
            this.listNiifFiltered = []
            this.selectedNiifs = []
            this.selectAll = false
            this.selectAllNiifs = false
            this.searchNiif = ""
            this.searchNivel = ""
            this.critNiifCode = ""
            this.critNiifName = ""
            this.showNiif = false
            this.showSuma = false
        },

        getFirstLevelDescription(levelDescripcion) {
            return levelDescripcion ? levelDescripcion.levelDescripcion : '-'
        },

        getSecondLevelDescription(levelDescripcion) {
            return levelDescripcion ? levelDescripcion.levelDescripcion : '-'
        },

        onNiifCheckboxChange(niif) {
            if (niif._selected) {
                if (!this.selectedNiifs.some(n => n.niif === niif.niif)) this.selectedNiifs.push(niif)
            } else {
                this.selectedNiifs = this.selectedNiifs.filter(n => n.niif !== niif.niif)
            }
            this.updateSelectAllState()
        },

        cargarDatosCuenta(valNuevo) {
            if (!valNuevo || valNuevo.length === 0) return
            
            const valNew = valNuevo[0]
            this.info = valNew
            this.chk = ''
            this.contable = valNew.contable
            this.cuenta = valNew.cuenta
            this.actual = valNew.actual
            this.operacion = valNew.operacion
            this.formulacion = valNew.formulacion
            this.vigencia = valNew.vigencia
            this.id_compania = valNew.id_compania
            this.codReporte = valNew.codReporte

            // Resetear selecciones
            this.selectedNiifs = []
            this.listNiifFiltered = [...this.listNiif]
            this.listNiif.forEach(n => n._selected = false)

            // Determinar tipo de formulación
            if (valNew.formulacion) {
                const form = valNew.formulacion
                
                if (form === "MANUAL" || form === "M") {
                    this.chk = 'm'
                    this.showNiif = false
                    this.showSuma = false
                } else if (form === "AC") {
                    this.chk = 'a'
                    this.showNiif = false
                    this.showSuma = false
                } else if (form === "MC") {
                    this.chk = 'ac'
                    this.showNiif = false
                    this.showSuma = false
                } else if (form.startsWith("S") || form.startsWith("s")) {
                    this.chk = 's'
                    this.showSuma = true
                    this.showNiif = false
                    this.formulacion = form.replace(/^[Ss]/, '').trim()
                } else if (form.includes("Niif") || form.includes("NIIF")) {
                    this.chk = 'n'
                    this.showNiif = true
                    this.showSuma = false
                    
                    // Extraer los NIIFs
                    let niifStr = form.replace(/Niif\(/i, '').replace(/\)/g, '')
                    this.arrNiif = niifStr.split(',').map(n => n.trim()).filter(n => n !== '')
                    
                    // Seleccionar los NIIFs en la lista
                    this.cargarNiif()
                    setTimeout(() => {
                        this.listNiifFiltered.forEach((v_niif, idx) => {
                            const vl_niif = v_niif.niif.toString()
                            if (this.arrNiif.includes(vl_niif)) {
                                this.listNiifFiltered[idx]._selected = true
                                if (!this.selectedNiifs.some(n => String(n) === vl_niif)) {
                                    this.selectedNiifs.push(v_niif.niif)
                                }
                            }
                        })
                        this.updateSelectAllNiifs()
                    }, 300)
                }
            }
        }
    },

    mounted() {
        this.clearFields()

        if (this.$route.name == "nivelesADM") {
            this.administrador = true
        }

        // Cargar NIIF
        if (this.vigComSelected && this.vigComSelected.vigencia) {
            PlanConsolidacion.getPlanConsPorCompVige(
                this.vigComSelected.vigencia,
                this.vigComSelected.codReporte
            )
            .then((res) => {
                this.listNiif = res.data.planConsNiif || []
                this.listNiif.forEach(n => n._selected = false)
                this.selectedNiifs = []
                this.listNiifFiltered = [...this.listNiif]
            })
            .catch((err) => console.log(err))
        }

        // Cargar datos de la cuenta si ya existen
        if (this.dataDetallCuent && this.dataDetallCuent.length > 0) {
            this.cargarDatosCuenta(this.dataDetallCuent)
        }
    },

    watch: {
        dataDetallCuent(valNuevo) {
            this.cargarDatosCuenta(valNuevo)
        },

        chk() {
            this.actualizarVistaFormulacion()
        }
    }
}
</script>

<style src="../main.css"></style>

<style scoped>
/* ========== ESTILOS DEL MODAL ========== */
.uniform-modal-body {
    padding: 8px 4px 4px 4px;
}

.uniform-form-row {
    margin-bottom: 12px;
}

.uniform-label-col label {
    margin-bottom: 0;
    font-weight: 500;
    font-size: 14px;
}

.form-input {
    width: 100%;
    height: 38px;
    font-size: 14px;
    border-radius: 7px;
}

/* ========== HEADER DEL MODAL ========== */
.reset-modal-header {
    background-color: #2e507a;
    color: white;
    padding: 16px 20px;
    border-radius: 8px 8px 0 0;
}

.reset-modal-title {
    font-size: 18px;
    font-weight: 600;
    margin: 0;
}

.reset-modal-body {
    padding: 24px 20px;
    background-color: #f8f9fa;
}

/* ========== CRITERIO DE BÚSQUEDA ========== */
.criterio-inputs-wrapper {
    display: flex;
    flex-direction: column;
    gap: 6px;
    width: 100%;
}

.accounts-section {
    margin-top: 8px;
}

.select-all-container {
    padding: 4px 0;
}

/* ========== TABLA SCROLLABLE ========== */
.custom-scroll-table {
    height: 200px !important;
    min-height: 200px !important;
    max-height: 200px !important;
    overflow-y: auto !important;
    overflow-x: hidden !important;
    display: block !important;
    position: relative !important;
}

.custom-scroll-table table {
    display: table !important;
    width: 100% !important;
    table-layout: fixed !important;
    margin-bottom: 0 !important;
    border-collapse: separate !important;
    border-spacing: 0 !important;
}

.custom-scroll-table table thead {
    display: table-header-group !important;
    width: 100% !important;
    position: sticky !important;
    top: 0 !important;
    z-index: 10 !important;
}

.custom-scroll-table table thead tr {
    display: table-row !important;
    width: 100% !important;
}

.custom-scroll-table table thead th {
    background-color: #f8f9fa !important;
    border-bottom: 2px solid #dee2e6 !important;
    padding: 6px 8px !important;
    font-weight: 600 !important;
    font-size: 12px !important;
    color: #495057 !important;
    position: sticky !important;
    top: 0 !important;
    z-index: 10 !important;
    text-overflow: ellipsis !important;
    overflow: hidden !important;
    white-space: nowrap !important;
}

.custom-scroll-table table thead th:first-child {
    width: 120px !important;
    min-width: 120px !important;
    max-width: 120px !important;
}

.custom-scroll-table table thead th:last-child {
    width: auto !important;
}

.custom-scroll-table table tbody {
    display: table-row-group !important;
    width: 100% !important;
}

.custom-scroll-table table tbody tr {
    display: table-row !important;
    width: 100% !important;
    cursor: pointer !important;
    border-radius: 8px !important;
}

.custom-scroll-table table tbody td {
    padding: 5px 8px !important;
    border: none !important;
    text-overflow: ellipsis !important;
    overflow: hidden !important;
    white-space: nowrap !important;
    vertical-align: middle !important;
}

.custom-scroll-table table tbody td:first-child {
    width: 120px !important;
    min-width: 120px !important;
    max-width: 120px !important;
    border-radius: 8px 0 0 8px !important;
}

.custom-scroll-table table tbody td:last-child {
    width: auto !important;
    border-radius: 0 8px 8px 0 !important;
}

.custom-scroll-table table tbody tr:hover td {
    background-color: #f5f9ff !important;
}

.custom-scroll-table::-webkit-scrollbar {
    width: 8px !important;
}

.custom-scroll-table::-webkit-scrollbar-track {
    background: #f1f1f1 !important;
    border-radius: 4px !important;
}

.custom-scroll-table::-webkit-scrollbar-thumb {
    background: #c1c1c1 !important;
    border-radius: 4px !important;
}

.custom-scroll-table::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8 !important;
}

.table-active-blue {
    background-color: #e3f0ff !important;
    border-radius: 8px !important;
}

.table-active-blue td {
    background-color: #e3f0ff !important;
}

.table-active-blue td:first-child {
    border-radius: 8px 0 0 8px !important;
}

.table-active-blue td:last-child {
    border-radius: 0 8px 8px 0 !important;
}

/* ========== CHECKBOX NATIVOS ========== */
.custom-checkbox-wrapper {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    cursor: pointer;
}

.custom-checkbox-wrapper input[type="radio"] {
    width: 16px;
    height: 16px;
    accent-color: #2e507a;
    cursor: pointer;
    margin: 0;
    flex-shrink: 0;
}

.custom-checkbox-wrapper label {
    margin: 0;
    font-size: 14px;
    font-weight: 400;
    color: #495057;
    cursor: pointer;
}

.gap-2 {
    gap: 8px;
}

.gap-3 {
    gap: 12px;
}

/* ========== BOTONES ========== */
.reset-dialog-actions {
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    margin-top: 20px;
    padding-top: 16px;
    border-top: 1px solid #e9ecef;
}

.reset-btn-primary {
    background-color: #2e507a !important;
    border: 1px solid #2e507a !important;
    color: white !important;
    padding: 8px 24px;
    border-radius: 6px;
    font-weight: 500;
}

.reset-btn-primary:hover:not(:disabled) {
    background-color: #1f3f62 !important;
    border-color: #1f3f62 !important;
}

.reset-btn-primary:disabled {
    opacity: 0.65;
    cursor: not-allowed;
}

.reset-btn-secondary {
    background-color: #f8f9fa !important;
    border: 1px solid #ced4da !important;
    color: #495057 !important;
    padding: 8px 24px;
    border-radius: 6px;
    font-weight: 500;
}

.reset-btn-secondary:hover:not(:disabled) {
    background-color: #e9ecef !important;
    border-color: #adb5bd !important;
}

/* ========== RESPONSIVE ========== */
@media (max-width: 768px) {
    .custom-scroll-table {
        height: 160px !important;
        min-height: 160px !important;
        max-height: 160px !important;
    }

    .custom-scroll-table table thead th:first-child,
    .custom-scroll-table table tbody td:first-child {
        width: 80px !important;
        min-width: 80px !important;
        max-width: 80px !important;
        font-size: 11px !important;
    }

    .custom-scroll-table table tbody td {
        font-size: 12px !important;
        padding: 4px 6px !important;
    }

    .custom-scroll-table table thead th {
        font-size: 11px !important;
        padding: 4px 6px !important;
    }
}

@media (max-width: 576px) {
    .uniform-label-col {
        flex: 0 0 100%;
        max-width: 100%;
        margin-bottom: 4px;
        text-align: left !important;
    }
    
    .uniform-form-row .col-md-8,
    .uniform-form-row .col-md-9 {
        flex: 0 0 100%;
        max-width: 100%;
    }

    .custom-scroll-table {
        height: 140px !important;
        min-height: 140px !important;
        max-height: 140px !important;
    }

    .custom-scroll-table table thead th:first-child,
    .custom-scroll-table table tbody td:first-child {
        width: 60px !important;
        min-width: 60px !important;
        max-width: 60px !important;
        font-size: 10px !important;
    }

    .custom-scroll-table table tbody td {
        font-size: 11px !important;
        padding: 3px 4px !important;
    }

    .custom-scroll-table table thead th {
        font-size: 10px !important;
        padding: 3px 4px !important;
    }

    .custom-checkbox-wrapper {
        gap: 4px;
    }

    .custom-checkbox-wrapper input[type="radio"] {
        width: 14px;
        height: 14px;
    }

    .custom-checkbox-wrapper label {
        font-size: 13px;
    }

    .gap-3 {
        gap: 8px;
    }

    .reset-btn-primary,
    .reset-btn-secondary {
        width: 100%;
        margin: 4px 0 !important;
    }

    .reset-dialog-actions {
        flex-direction: column;
    }

    .reset-dialog-actions .reset-btn-secondary,
    .reset-dialog-actions .reset-btn-primary {
        width: 100%;
        margin: 4px 0 !important;
    }
}
</style>